export default __webpack_public_path__ + "static/media/file.590209cf.svg";